export enum FLOW_FILE_PATH {
    flow = 'flows.json',
    readme = "README.md",
    dockerfile = "Dockerfile",
    request_schema = "request_schema.json",
    response_schema = "response_schema.json",
}

export const Flow_Default_Files: string[] = [
    FLOW_FILE_PATH.dockerfile,
    FLOW_FILE_PATH.flow,
    FLOW_FILE_PATH.readme,
    FLOW_FILE_PATH.request_schema,
    FLOW_FILE_PATH.response_schema,
]